import { ApolloLink, Observable, Operation, NextLink, FetchResult } from '@apollo/client';
import { OperationQueuing } from './queuing';
import { GetGloballyAccessibleMultiAuthContext } from './hybrid-apollo-client';

const DEBUG = false;

// Adopted from https://github.com/newsiberian/apollo-link-token-refresh/tree/master/src
export class TokenRefreshLink extends ApolloLink {
  private queue: OperationQueuing;
  private fetching: boolean;

  constructor() {
    super();
    this.queue = new OperationQueuing();
    this.fetching = false;
  }

  public request(operation: Operation, forward: NextLink): Observable<FetchResult> {
    if (typeof forward !== 'function') {
      throw new Error('[Token Refresh Link]: Token Refresh Link is non-terminating link and should not be the last in the composed chain');
    }
    // If token does not exists, which could means that this is a not registered
    // user request, or if it is does not expired -- act as always

    const context = operation.getContext();
    if (context.noAuth) {
      return forward(operation);
    }
    if (!this.fetching) {
      const multiAuthObject = GetGloballyAccessibleMultiAuthContext()!;
      const isJWTExpired = multiAuthObject.areTokensExpired();
      if (!isJWTExpired) {
        return forward(operation);
      }
      this.fetching = true;
      // Perform JWT refresh
      (async () => {
        try {
          // Do api call
          await multiAuthObject.refreshTokens();
          await new Promise((resolve) => setTimeout(resolve, 100));
          this.queue.consumeQueue();
        } catch (err) {
          // There was some error. Logout and nuke the queue
          this.queue.nukeQueue();
          await multiAuthObject.globalSignOut();
        } finally {
          this.fetching = false;
        }
      })();
    }
    return this.queue.enqueueRequest({
      operation,
      forward,
    });
  }
}
